export default Object.freeze({
  Unset: -1,
  Pending: false,
  Uploaded: true,
});
